<mat-dialog-content style="overflow: unset;height: 100%;">

    <a mat-dialog-close class="boxclose" id="boxclose"></a>

    <iframe [src]="srcHelp | safe" width="100%" height="100%"> </iframe>

</mat-dialog-content>
